/* eslint-disable no-unused-vars */
export default [
  // Ad Schedules Routing
  {
    path: '/:projectId/ad-schedules',
    component: () => import('@/views/adSchedules/AdSchedule.vue'),
    meta: {
      titleText: 'Ad Schedules',
      parentText: 'Dashboard',
      contentClass: 'ad-schedules',
      navActiveLink: 'ad-schedules',
      gjIcon: 'Money',
      breadcrumb: [
        {
          text: 'Ad schedules',
          to: 'ad-schedules',
          active: true,
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'ad-schedules',
        component: () => import('@/views/adSchedules/AdSchedules.vue'),
        meta: {
          titleText: 'Ad Schedules',
          parentText: 'Dashboard',
          contentClass: 'ad-schedules',
          navActiveLink: 'ad-schedules',
          gjIcon: 'Money',
          action: 'read',
          resource: 'ads',
          breadcrumb: [
            {
              text: 'Ad schedules',
              to: 'ad-schedules',
              active: true,
            },
          ],
        },
      },
      {
        path: ':id',
        name: 'ad-schedules-edit',
        component: () => import('@/views/adSchedules/Edit.vue'),
        meta: {
          titleText: 'Ad Schedules',
          parentText: 'Dashboard',
          contentClass: 'ad-schedule',
          navActiveLink: 'ad-schedules',
          gjIcon: 'Money',
          action: 'execute',
          resource: 'ads',
          projectRequired: true,
          breadcrumb: [
            {
              text: 'Ad schedules',
              to: 'ad-schedules',
            },
            {
              dynamic: true,
              text: 'Edit Ad Schedule',
              active: true,
            },
          ],
        },
      },
    ],
  },

  {
    path: '/:projectId/demand-manager',
    name: 'demand-manager',
    component: () => import('@/views/adSchedules/wrappers/Wrappers.vue'),
    meta: {
      titleText: 'Wrappers',
      parentText: 'Dashboard',
      contentClass: 'demand-manager',
      navActiveLink: 'demand-manager',
      gjIcon: 'Money',
      action: 'read',
      resource: 'ads',
      projectRequired: true,
      breadcrumb: [
        {
          text: 'Demand Manager',
          to: 'demand-manager',
          active: true,
        },
      ],
    },

  },
  {
    path: '/:projectId/demand-manager/add',
    name: 'wrappers-add',
    component: () => import('@/views/adSchedules/wrappers/Add.vue'),
    meta: {
      titleText: 'Demand Manager',
      parentText: 'Dashboard',
      contentClass: 'wrapper',
      navActiveLink: 'demand-manager',
      gjIcon: 'Money',
      action: 'execute',
      resource: 'ads',
      projectRequired: true,
      breadcrumb: [
        {
          text: 'Demand Manager',
          to: 'demand-manager',
        },
        {
          dynamic: false,
          text: 'Create Wrapper',
          active: true,
        },
      ],
    },
  },
  {
    path: '/:projectId/view/demand-manager/:id',
    name: 'wrappers-view',
    component: () => import('@/views/adSchedules/wrappers/View.vue'),
    meta: {
      titleText: 'Demand Manager',
      parentText: 'Dashboard',
      contentClass: 'demand-manager',
      navActiveLink: 'demand-manager',
      gjIcon: 'Money',
      action: 'execute',
      resource: 'ads',
      projectRequired: true,
      breadcrumb: [
        {
          text: 'Demand Manager',
          to: 'demand-manager',
        },
        {
          dynamic: false,
          text: 'View Wrapper',
          active: true,
        },
      ],
    },
  },

  // Outstream Players Routing
  {
    path: '/:projectId/outstream-players',
    component: () => import('@/views/players/outstream/Player.vue'),
    children: [
      {
        path: '',
        name: 'outstream-players',
        component: () => import('@/views/players/outstream/Players.vue'),
        meta: {
          titleText: 'Outstream Players',
          parentText: 'Dashboard',
          contentClass: 'outstream-players',
          navActiveLink: 'outstream-players',
          gjIcon: 'Player',
          action: 'read',
          resource: 'player',
          breadcrumb: [
            {
              text: 'Outstream Players',
              active: true,
            },
          ],
        },
      },
      {
        path: '',
        component: () => import('@/views/players/outstream/Add.vue'),
        children: [
          {
            path: '/:projectId/outstream-players/add/customize',
            name: 'outstream-players-customize-add',
            component: () => import('@/views/players/components/Customize.vue'),
            props: {
              module: 'outstreamPlayersModule',
              colorsSectionIcons: ['Filters'],
              hasLogo: false,
            },
            meta: {
              title: '',
              titleText: 'Outstream Players',
              parentText: 'Dashboard',
              contentClass: 'outstream-players',
              navActiveLink: 'outstream-players',
              gjIcon: 'Player',
              action: 'execute',
              resource: 'player',
              breadcrumb: [
                {
                  text: 'Outstream Players',
                  to: 'outstream-players',
                },
                {
                  text: 'New outstream player',
                  active: true,
                },
              ],
            },
          },
          {
            path: '/:projectId/outstream-players/add/:tab?',
            name: 'outstream-players-add',
            component: () => import('@/views/players/outstream/tabs/SetupTab.vue'),
            beforeEnter: (to, from, next) => {
              const { tab } = to.params
              const validGeneralValues = ['setup', undefined]

              if (!validGeneralValues.includes(tab)) {
                const errorPath = '/error-404'
                next(errorPath)
              } else {
                next()
              }
            },
            meta: {
              title: '',
              titleText: 'outstream Players',
              parentText: 'Dashboard',
              contentClass: 'outstream-player',
              navActiveLink: 'outstream-players',
              gjIcon: 'Player',
              action: 'execute',
              resource: 'player',
              breadcrumb: [
                {
                  text: 'Outstream Players',
                  to: 'outstream-players',
                },
                {
                  text: 'New Outstream player',
                  active: true,
                },
              ],
            },
          },
          {
            path: '/:projectId/outstream-players/:id/customize',
            name: 'outstream-players-customize-edit',
            component: () => import('@/views/players/components/Customize.vue'),
            props: {
              module: 'outstreamPlayersModule',
              colorsSectionIcons: ['Filters'],
              hasLogo: false,
            },
            meta: {
              title: '',
              titleText: 'Outstream Players',
              parentText: 'Dashboard',
              contentClass: 'outstream-player',
              navActiveLink: 'outstream-players',
              gjIcon: 'Player',
              action: 'execute',
              resource: 'player',
              breadcrumb: [
                {
                  text: 'Outstream Players',
                  to: 'outstream-players',
                },
                {
                  dynamic: true,
                  text: 'Edit Outstream Player',
                  active: true,
                },
              ],
            },
          },
          {
            path: '/:projectId/outstream-players/:id/:tab?',
            name: 'outstream-players-edit',
            component: () => import('@/views/players/outstream/tabs/SetupTab.vue'),
            beforeEnter: (to, from, next) => {
              const { tab } = to.params
              const validGeneralValues = ['setup', undefined]

              if (!validGeneralValues.includes(tab)) {
                const errorPath = '/error-404'
                next(errorPath)
              } else {
                next()
              }
            },
            meta: {
              title: '',
              titleText: 'Outstream Players',
              parentText: 'Dashboard',
              contentClass: 'outstream-player',
              navActiveLink: 'outstream-players',
              gjIcon: 'Player',
              action: 'execute',
              resource: 'player',
              breadcrumb: [
                {
                  text: 'Outstream Players',
                  to: 'outstream-players',
                },
                {
                  dynamic: true,
                  text: 'Edit Outstream Player',
                  active: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
]
